import React from 'react';
import EditVideoPackagePaymentSettingComponent from '../../../Components/VideoPackagePaymentSetting/EditVideoPackagePaymentSetting';

export default function EditVideoPackagePaymentSetting() {
    return (
        <div className='page-body'>
            <EditVideoPackagePaymentSettingComponent />
        </div>
    );
}